// images.ts

// Define image types for better TypeScript support

import logoSvg from '../assets/logoWithName.svg';
import googlePlay from '../assets/googlePlay.svg';
import appleStore from '../assets/appleStore.svg';

import listingBackground from '../assets/listingbackground.svg';
import allFilter from '../assets/filters/all_filter.webp'
import hinduFilter from '../assets/filters/hindu_filter.webp'
import sikhFilter from '../assets/filters/sikh_filter.webp'
import muslimFilter from '../assets/filters/muslim_filter.webp'
import christanFilter from '../assets/filters/christian_filter.webp'
import bengaliFilter from '../assets/filters/bengali_filter.webp'
import instagram from '../assets/instagram.svg'
import facebook from '../assets/facebook.svg'
import dropdown from '../assets/dropdown.svg'
import filterIcon from '../assets/filterIcon.svg'
import weddingInvitationBackground from '../assets/weddingInvitationBackground.png'
import specialDayBackground from '../assets/specialDayBackground.svg'
import mail from '../assets/mail.svg'  
import profile from '../assets/profile.svg'
import logo from '../assets/logo.svg'
import location from '../assets/location.svg'


import splashScreen from '../assets/splashScreen.webp'

import downloadImageIcon from '../assets/download__image_icon.svg'
import printIcon from '../assets/print_icon.svg'
import pdfIcon from '../assets/pdf_icon.svg'
import orderIcon from '../assets/order_icon.svg'
import hdIcon from '../assets/hd_icon.svg'
import loveIcon from '../assets/love_icon.svg'
import supportTeamIcon from '../assets/support_team_icon.svg'
import shareIcon from '../assets/share_icon.svg'
import yellowHeart from '../assets/heart_yellow.svg'
import ring from '../assets/ring.svg'
import flowers from '../assets/flowers.svg'
import music from '../assets/music.svg'
import celebrate from '../assets/celebrate.svg'
import centerAlign from '../assets/center-align.svg'
import duplicate from '../assets/duplicate.svg'
import deleteIcon from '../assets/delete.svg'
import errorImg from '../assets/error.png'
import blogsBackground from '../assets/blogs_bg.webp'
import backIcon from '../assets/back_icon.svg'
import eye from '../assets/eye.svg'
import reset from '../assets/reset.svg'

// Main images object with all website assets
const images = {
    // Branding
    resetIcon: {
      src: reset.src,
      alt: 'Reset',
    },
    eyeIcon: {
      src: eye.src,
      alt: 'Preview',
    },
    backIcon: {
      src: backIcon.src,
      alt: 'back',
    },
    blogsBg: {
      src: blogsBackground.src,
      alt: 'blogsBackground',
    },
    error: {
      src: errorImg.src,
      alt: 'error',
    },
    order: {
      src: orderIcon.src,
      alt: 'order',
    },
    supportTeamIcon: {
      src: supportTeamIcon.src,
      alt: 'order',
    },
    loveIcon: {
      src: loveIcon.src,
      alt: 'order',
    },
    hdIcon: {
      src: hdIcon.src,
      alt: 'order',
    },
    delete: {
      src: deleteIcon.src,
      alt: 'delete',
    },
    duplicate: {
      src: duplicate.src,
      alt: 'duplicate',
    },
    centerAlign: {
      src: centerAlign.src,
      alt: 'center-align',
    },
    celebrate: {
      src: celebrate.src,
      alt: 'celebrate',
    },
    music: {
      src: music.src,
      alt: 'music',
    },
    ring: {
      src: ring.src,
      alt: 'ring',
    },
    flowers: {
      src: flowers.src,
      alt: 'flower',
    },
    yellowHeart: {
      src: yellowHeart.src,
      alt: 'heart',
    },
    downloadImageIcon: {
      src: downloadImageIcon.src,
      alt: 'Image',
    },
    downloadPdfIcon: {
      src: pdfIcon.src,
      alt: 'pdf',
    },
    printIcon: {
      src: printIcon.src,
      alt: 'print',
    },
    shareIcon: {
      src: shareIcon.src,
      alt: 'share',
    },
    splash: {
      src: splashScreen.src,
      alt: 'splashScreen',
    },
    logoWithName: {
      src: logo.src,
      alt: 'logo',
    },
    listingBackground: {
      src: listingBackground.src,
      alt: 'Background',
    },
    profile: {
      src: profile.src,
      alt: 'Customer',
    },
    mail: {
      src: mail.src,
      alt: 'Email',
    },
    location: {
      src: location.src,
      alt: 'Location',
    },
    weddingInvitationBackground: {
      src: weddingInvitationBackground.src,
      alt: 'Filters',
    },
    specialDayBackground: {
      src: specialDayBackground.src,
      alt: 'Filters',
    },
    filters: {
      src: filterIcon.src,
      alt: 'Filters',
    },
    facebook: {
      src: facebook.src,
      alt: 'Facebook',
    },
    dropdown: {
      src: dropdown.src,
      alt: 'Dropdown',
    },
    instagram: {
      src: instagram.src,
      alt: 'Instagram',
    },
    logo: {
      src: logoSvg.src,
      alt: 'MyWeddinglyInvites',
    },
    
      allFilter: {
        src: allFilter.src,
        alt: 'All Filter',
      },
      englishFilter: {
        src: allFilter.src,
        alt: 'English Filter',
      },
      marathiFilter: {
        src: allFilter.src,
        alt: 'Marathi Filter',
      },
      hinduFilter: {
        src: hinduFilter.src,
        alt: 'Hindu Filter',
      },
      sikhFilter: {
        src: sikhFilter.src,
        alt: 'Sikh Filter',
      },
      muslimFilter: {
        src: muslimFilter.src,
        alt: 'Muslim Filter',
      },
     christianFilter: {
        src: christanFilter.src,
        alt: 'Christian Filter',
      },
      bengaliFilter: {
        src: bengaliFilter.src,
        alt: 'Bengali Filter',
      },
    googlePlay: {
        src: googlePlay.src,
        alt: 'Download on the Play Store',
      },
    appleStore: {
        src: appleStore.src,
        alt: 'Download on the App Store',
      },

  };
  
  export default images;